/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_B1_DInputs */

const en_mk_abt_b1_d = /** @type {(inputs: Mk_Abt_B1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent accountable to nobody is not a colleague, it is a risk. So every agent here works on someone’s behalf and is judged by that person’s permissions.`)
};

const id_mk_abt_b1_d = /** @type {(inputs: Mk_Abt_B1_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen yang tidak bertanggung jawab kepada siapa pun bukan rekan kerja, melainkan risiko. Karena itu setiap agen di sini bekerja atas nama seseorang dan dinilai dengan izin orang itu.`)
};

/**
* | output |
* | --- |
* | "An agent accountable to nobody is not a colleague, it is a risk. So every agent here works on someone’s behalf and is judged by that person’s permissions." |
*
* @param {Mk_Abt_B1_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_b1_d = /** @type {((inputs?: Mk_Abt_B1_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_B1_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_b1_d(inputs)
	return en_mk_abt_b1_d(inputs)
});